import type { NewsItem } from "@/types";

export const newsTags = ["全部", "新剧发布", "演员动态", "剧情解析", "行业观察"];

export const news: NewsItem[] = [
  {
    id: 1,
    title: "《星月之约》开播即登顶热搜，跨越时空的爱情为何如此上头",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20romantic%20drama%20scene%20under%20a%20starry%20sky%20with%20soft%20pink%20glow%2C%20dreamy%20atmosphere%2C%20editorial%20photo&width=800&height=500&seq=news-cover-01&orientation=landscape",
    summary: "由李承宰、朴敏彩主演的《星月之约》首播便拿下同时段收视第一，跨越时空的宿命感成为观众讨论的焦点。",
    author: "编辑 林夕",
    date: "2025-10-08",
    tag: "新剧发布",
    content: [
      "由李承宰、朴敏彩领衔主演的爱情奇幻剧《星月之约》于上周正式开播，首播当晚便登上了多个社交平台的热搜榜单，成为秋季档最受关注的作品之一。",
      "该剧讲述了天文学家车允熙（朴敏彩 饰）与旧时代青年韩世洲（李承宰 饰）通过星空的信号跨越百年相识的故事。编剧郑慧琳在接受采访时表示，整部剧的核心命题是“在注定无法拥有的感情里，人还愿意付出多少”。",
      "从目前已播出的剧集来看，作品在摄影与配乐上的用心程度广受好评，星空下的每一场对手戏都被观众称为“壁纸级画面”。",
      "不过也有观众认为节奏在前两集略显缓慢。随着主线逐渐铺开，后续口碑走向仍值得期待。",
    ],
    relatedDramaIds: [1],
  },
  {
    id: 2,
    title: "悬疑剧《首尔迷雾》大结局解析：那些被忽略的伏笔你都发现了吗",
    cover: "https://readdy.ai/api/search-image?query=Rainy%20Seoul%20street%20at%20night%20with%20neon%20reflections%2C%20moody%20crime%20thriller%20atmosphere%2C%20editorial%20photo&width=800&height=500&seq=news-cover-02&orientation=landscape",
    summary: "《首尔迷雾》正式收官，编剧埋下的细节超出想象，本文为你梳理大结局中的关键线索与隐藏彩蛋。",
    author: "编辑 周迟",
    date: "2025-10-06",
    tag: "剧情解析",
    content: [
      "《首尔迷雾》在播出十二集后正式收官，凭借扎实的剧本与克制的叙事，成为今年口碑最好的犯罪悬疑剧之一。",
      "大结局中，主角姜道贤（姜道贤 饰）终于揭开了十年前旧案的全貌，但结局并没有给出传统意义上的“胜利”，而是留下了一个开放式的问号。",
      "细心的观众或许已经注意到，剧中多次出现的雨天意象与主角的内心状态相互映照，导演崔民浩擅长用环境描写人物。",
      "此外，第一集中一闪而过的报纸标题，其实是最终真相的第一次暗示。二刷的观众给出了不少有趣的解读。",
    ],
    relatedDramaIds: [2],
  },
  {
    id: 3,
    title: "崔秀珍凭《王宫医女》再获演技好评，古装女神名副其实",
    cover: "https://readdy.ai/api/search-image?query=Elegant%20Korean%20historical%20drama%20scene%20in%20a%20royal%20palace%20with%20warm%20golden%20light%2C%20editorial%20photo&width=800&height=500&seq=news-cover-03&orientation=landscape",
    summary: "崔秀珍在《王宫医女》中饰演医女崔莲伊，细腻又有层次的表演赢得观众一致认可，被认为是她演艺生涯的代表作。",
    author: "编辑 苏亚",
    date: "2025-10-04",
    tag: "演员动态",
    content: [
      "在古装剧《王宫医女》中，崔秀珍挑战了一位身处宫廷却坚持医者信念的女性角色，从青涩少女到独当一面的医女，跨度不小。",
      "不少观众表示，崔秀珍在诊脉、施药时的细微表情处理非常到位，让人相信她真的是一位行医之人。",
      "剧组透露，为了演好这个角色，崔秀珍提前学习了传统医理与礼仪课程，每天收工后还会留下来与导演磨合台词。",
      "随着剧集完结，关于她下一部作品的讨论也逐渐增多，观众期待她带来更多不同类型的角色。",
    ],
    relatedDramaIds: [4],
  },
  {
    id: 4,
    title: "十月韩剧前瞻：三部待播新剧值得加入追剧清单",
    cover: "https://readdy.ai/api/search-image?query=Autumn%20Seoul%20street%20with%20warm%20tone%20and%20subtle%20blurred%20city%20lights%2C%20editorial%20mood&width=800&height=500&seq=news-cover-04&orientation=landscape",
    summary: "十月的韩剧市场迎来新一轮上新，爱情、悬疑与科幻各有看点，本文为你梳理最值得关注的三部作品。",
    author: "编辑 顾言",
    date: "2025-10-02",
    tag: "新剧发布",
    content: [
      "进入十月，韩剧市场再次迎来密集上新。从目前公布的排播信息来看，爱情、悬疑与科幻三大类型都有重量级作品登场。",
      "首先是由玄彬宇、韩素希主演的科幻剧《明日之地》，末世背景下的生存与人性选择是最大看点。",
      "其次是马东锡回归小荧幕的动作悬疑剧《双面追凶》，硬核的追凶线与镜像式的叙事结构颇具新意。",
      "此外，由安晓妍主演的轻松爱情喜剧《甜蜜告白》适合在忙碌一天后放松观看，甜而不腻。",
    ],
    relatedDramaIds: [9, 11, 8],
  },
  {
    id: 5,
    title: "为什么我们总被“青春怀旧剧”打动：《那年盛夏》的共鸣密码",
    cover: "https://readdy.ai/api/search-image?query=Sunlit%20coastal%20road%20in%20Korea%20with%20green%20trees%2C%20warm%20nostalgic%20summer%20tone%2C%20editorial%20photo&width=800&height=500&seq=news-cover-05&orientation=landscape",
    summary: "《那年盛夏》用一场1998年的小镇往事，唤起了观众关于青春与遗憾的共同记忆。",
    author: "编辑 林夕",
    date: "2025-09-28",
    tag: "剧情解析",
    content: [
      "《那年盛夏》没有宏大的情节，却凭借真实细腻的青春描写打动了大量观众。",
      "剧中的海边小镇、蝉鸣、旧相机，构成了一代人对夏天的集体记忆。编剧柳娜英表示，她希望写的是一个“没有答案的夏天”。",
      "有评论指出，青春怀旧剧之所以动人，是因为它让观众同时看到了曾经的自己与那个再也回不去的时代。",
      "结尾那句没有说出口的告别，成为全剧最让人意难平的瞬间。",
    ],
    relatedDramaIds: [3],
  },
  {
    id: 6,
    title: "医疗剧《重启心跳》热播：职业剧如何拍得有温度又有力度",
    cover: "https://readdy.ai/api/search-image?query=Modern%20Korean%20hospital%20interior%20with%20soft%20daylight%20and%20clean%20tones%2C%20editorial%20photo&width=800&height=500&seq=news-cover-06&orientation=landscape",
    summary: "《重启心跳》在紧张的手术戏与人物情感之间找到了平衡，让职业剧不再只是“技术展示”。",
    author: "编辑 周迟",
    date: "2025-09-25",
    tag: "剧情解析",
    content: [
      "医疗剧向来考验制作水准，因为既要保证专业度，又要兼顾情感表达。《重启心跳》在这两点上做得相当扎实。",
      "剧中大量手术场景采用手持镜头与紧凑剪辑，营造出真实的手术室氛围，让观众跟着屏住呼吸。",
      "而在手术之外，编剧用社区医院这样一个相对“小”的舞台，讲出了关于医者初心的故事。",
      "有观众评论：“它让我相信，好好做一件小事的人，本身就值得被尊重。”",
    ],
    relatedDramaIds: [5],
  },
  {
    id: 7,
    title: "《无声证词》口碑逆袭：慢热悬疑剧凭什么后来居上",
    cover: "https://readdy.ai/api/search-image?query=Dramatic%20courtroom%20interior%20with%20warm%20wood%20and%20soft%20spotlight%2C%20editorial%20photo&width=800&height=500&seq=news-cover-07&orientation=landscape",
    summary: "开播时并不起眼的《无声证词》，靠着扎实的剧本在后半程实现口碑反超。",
    author: "编辑 顾言",
    date: "2025-09-22",
    tag: "剧情解析",
    content: [
      "《无声证词》开播首周的表现并不算亮眼，但随着案件层层展开，讨论度一路走高。",
      "该剧最大的特点是“慢”。它不急于给出答案，而是让观众和主角一起，在证据与谎言之间反复推敲。",
      "孙艺珍饰演的检察官在法庭上的最后陈述，被不少观众称为今年最有力量的电视剧片段之一。",
      "事实证明，只要剧本扎实，慢热并不等于平庸。",
    ],
    relatedDramaIds: [7],
  },
  {
    id: 8,
    title: "甜宠剧的新方向：《甜蜜告白》如何把老题材拍出新意",
    cover: "https://readdy.ai/api/search-image?query=Bright%20pastel%20cherry%20blossom%20street%20in%20Korea%2C%20warm%20cheerful%20tone%2C%20editorial%20photo&width=800&height=500&seq=news-cover-08&orientation=landscape",
    summary: "同样是甜宠路线，《甜蜜告白》在人物设定与节奏处理上做出了不少新尝试。",
    author: "编辑 苏亚",
    date: "2025-09-19",
    tag: "剧情解析",
    content: [
      "甜宠剧容易被贴上“套路”的标签，但《甜蜜告白》在人物塑造上花了心思。",
      "女主角不是等待被拯救的“小白花”，而是经营甜品店的独立女性；男主角的挑剔背后，也有自己的成长弧线。",
      "剧中的美食镜头同样是加分项，很多观众表示“看饿了”。",
      "在被广泛讨论的甜宠赛道里，能做到甜而不腻并不容易。",
    ],
    relatedDramaIds: [8],
  },
  {
    id: 9,
    title: "科幻韩剧崛起？从《明日之地》看类型剧的新可能",
    cover: "https://readdy.ai/api/search-image?query=Futuristic%20post-apocalyptic%20city%20with%20cool%20teal%20sky%20and%20amber%20glow%2C%20editorial%20photo&width=800&height=500&seq=news-cover-09&orientation=landscape",
    summary: "韩剧在科幻类型上的投入逐年增加，《明日之地》是这一趋势下的最新样本。",
    author: "编辑 顾言",
    date: "2025-09-15",
    tag: "行业观察",
    content: [
      "过去提起韩剧，人们更多想到的是爱情与家庭。而近年来，科幻题材正在成为新的增长点。",
      "《明日之地》搭建了一套完整的世界观，从地下城市的配给制度到地表禁区的设定，都体现出制作的野心。",
      "业内人士认为，韩剧在类型化探索上的成功，离不开工业水准的提升与观众口味的多元化。",
      "当然，科幻不是万能药，如何在宏大设定中讲好人的故事，仍是从业者需要思考的问题。",
    ],
    relatedDramaIds: [9],
  },
  {
    id: 10,
    title: "治愈系慢综剧《花样厨房》：为什么“慢”反而成了稀缺品",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20rustic%20Korean%20countryside%20kitchen%20with%20fresh%20vegetables%20in%20warm%20light%2C%20editorial%20photo&width=800&height=500&seq=news-cover-10&orientation=landscape",
    summary: "在快节奏的今天，《花样厨房》用一道道家常菜与安静的小院，提供了一份难得的松弛感。",
    author: "编辑 苏亚",
    date: "2025-09-11",
    tag: "剧情解析",
    content: [
      "没有反转，没有狗血，《花样厨房》只是安安静静地讲一个人在乡下开小餐馆的故事。",
      "正是这种“慢”，让它在一众强情节作品中显得格外特别，也成为许多观众的“电子榨菜”。",
      "剧中的每一道菜都对应着一个人物或一段往事，食物成为了情感的载体。",
      "有观众说：“看完之后，我想回家给自己做一顿饭。”",
    ],
    relatedDramaIds: [10],
  },
  {
    id: 11,
    title: "从《江南往事》看家庭剧的长青之道",
    cover: "https://readdy.ai/api/search-image?query=Seoul%20residential%20neighborhood%20alley%20at%20dusk%20with%20warm%20lights%2C%20editorial%20photo&width=800&height=500&seq=news-cover-11&orientation=landscape",
    summary: "四十集的《江南往事》用一家三代人的日常，证明了家庭剧依然拥有庞大的观众基础。",
    author: "编辑 林夕",
    date: "2025-09-07",
    tag: "行业观察",
    content: [
      "长篇家庭剧曾一度被认为“过时”，但《江南往事》的表现说明，只要故事真实，观众一直都在。",
      "剧中朴家三代人的矛盾与和解，几乎能在每个普通家庭里找到影子。",
      "编剧河英美擅长在琐碎的日常中埋下情感的引线，一顿饭、一句话都可能成为全剧的泪点。",
      "所谓长青，不过是始终愿意认真讲普通人的故事。",
    ],
    relatedDramaIds: [6],
  },
  {
    id: 12,
    title: "马东锡回归小荧幕：《双面追凶》动作戏幕后揭秘",
    cover: "https://readdy.ai/api/search-image?query=Night%20city%20rooftop%20with%20warm%20orange%20streetlights%20and%20dark%20sky%2C%20cinematic%20action%20tone&width=800&height=500&seq=news-cover-12&orientation=landscape",
    summary: "《双面追凶》中拳拳到肉的动作设计引发热议，剧组公开了多场高难度动作戏的拍摄幕后。",
    author: "编辑 周迟",
    date: "2025-09-03",
    tag: "演员动态",
    content: [
      "作为备受观众喜爱的动作演员，马东锡此次回归小荧幕引发了不小关注。",
      "剧组透露，为了呈现真实感，大部分打斗镜头都由演员亲自完成，天台追逐戏更是连续拍摄了三个通宵。",
      "动作指导表示，本剧的动作设计强调“重量感”与“环境互动”，希望让每一场打斗都有叙事意义。",
      "除了动作，剧中镜像式的心理博弈同样是看点所在。",
    ],
    relatedDramaIds: [11],
  },
  {
    id: 13,
    title: "韩剧里的“生活感”从哪里来：美术与场景的功劳",
    cover: "https://readdy.ai/api/search-image?query=Warm%20sunlit%20study%20room%20with%20open%20notebooks%20and%20coffee%2C%20soft%20cream%20tones%2C%20editorial%20photo&width=800&height=500&seq=news-cover-13&orientation=landscape",
    summary: "一部剧是否让人信服，往往取决于那些不起眼的场景细节。本文聊聊韩剧美术设计的用心之处。",
    author: "编辑 顾言",
    date: "2025-08-30",
    tag: "行业观察",
    content: [
      "观众常说的“生活感”，很大程度来自美术与场景设计。",
      "在《恋恋笔记》中，编辑部里堆叠的稿件、窗边的旧台灯，都在无声地讲述着角色的职业与性格。",
      "好的美术不会喧宾夺主，它只是让观众在不经意间相信“这里真的有人住过”。",
      "这也是韩剧在细节上一贯的坚持。",
    ],
    relatedDramaIds: [12],
  },
  {
    id: 14,
    title: "《明日之地》世界观详解：地下城市的规则与隐喻",
    cover: "https://readdy.ai/api/search-image?query=Futuristic%20underground%20city%20with%20cool%20teal%20lighting%20and%20towering%20structures%2C%20editorial%20photo&width=800&height=500&seq=news-cover-14&orientation=landscape",
    summary: "《明日之地》构建了一个规则森严的地下城市，本文为你梳理其设定与背后的隐喻。",
    author: "编辑 周迟",
    date: "2025-08-26",
    tag: "剧情解析",
    content: [
      "《明日之地》最吸引人的，是它那套自洽而又令人不安的世界观。",
      "地下城市以“配给”维持秩序，每个人都被分配了明确的岗位，看似公平，实则剥夺了选择的权利。",
      "主角玄彬宇的觉醒，本质上是对“被安排的人生”的质疑。",
      "科幻外壳之下，剧集讨论的其实是每个人都可能面对的问题：我们究竟想要怎样活着。",
    ],
    relatedDramaIds: [9],
  },
  {
    id: 15,
    title: "新人编剧崛起：韩剧内容生态正在发生的变化",
    cover: "https://readdy.ai/api/search-image?query=Creative%20writing%20desk%20with%20notebooks%20and%20warm%20lamp%20light%2C%20editorial%20photo&width=800&height=500&seq=news-cover-15&orientation=landscape",
    summary: "越来越多新人编剧带着新鲜视角进入行业，为韩剧内容注入了新的活力。",
    author: "编辑 苏亚",
    date: "2025-08-22",
    tag: "行业观察",
    content: [
      "近年来，不少高口碑韩剧都出自新人编剧之手，他们带来了更贴近当下生活的表达方式。",
      "平台对原创内容的支持、编剧培养机制的完善，是这一变化的重要推手。",
      "新人编剧往往敢于尝试混合类型，《星月之约》将爱情与科幻元素融合，就是一次有趣的尝试。",
      "可以预见，未来的韩剧内容会更加多元，也更值得期待。",
    ],
    relatedDramaIds: [1, 9],
  },
];